import { createSelector } from 'reselect'

import { DATE_VALUES, getParsedDateUntilToday, getRangeFromDateFilter } from 'utils/dateUtils'

// `dashboard` is injected only while a Dashboard route is mounted and dropped
// again once another route takes over; in-flight subscriptions/epics can
// still read state in that window, so slice access must be null-safe (see
// AwarenessCenter/Campaigns/selectors.js precedent).
const EMPTY_OBJ = {}
const EMPTY_ARRAY = []
// Must mirror the reducer's initial `data` shape — List.js reads
// `data.items.length` unguarded, so a bare {} fallback recreates the
// unmounted-slice crash this file exists to prevent.
const EMPTY_DATA = { items: EMPTY_ARRAY }
const selectThreatProtectionList = (state) => state.dashboard?.threatProtection?.list ?? EMPTY_OBJ

const selectData = (state) => selectThreatProtectionList(state).data ?? EMPTY_DATA
const selectLoader = (state) => selectThreatProtectionList(state).loader ?? false
const selectError = (state) => selectThreatProtectionList(state).error ?? null

const selectListType = (state) => selectThreatProtectionList(state).listType

const selectSearch = (state) => selectThreatProtectionList(state).search ?? ''

const selectDateFilter = (state) =>
  selectThreatProtectionList(state).dateFilter ?? DATE_VALUES.MONTH
const selectDateFilterCustomRange = (state) => selectThreatProtectionList(state).feDateRange
const selectDateRange = createSelector(
  selectDateFilter,
  selectDateFilterCustomRange,
  (dateFilter, dateFilterCustomRange) => dateFilterCustomRange || getRangeFromDateFilter(dateFilter)
)
const selectParsedDate = (state) => {
  const currentDateFilter = selectDateFilter(state)
  return getParsedDateUntilToday(currentDateFilter)
}

const selectPage = (state) => selectThreatProtectionList(state).page ?? 1
const selectBannerTypeFilter = (state) =>
  selectThreatProtectionList(state).bannerTypeFilter ?? EMPTY_ARRAY
const selectIncidentTypeFilter = (state) =>
  selectThreatProtectionList(state).incidentTypeFilter ?? EMPTY_ARRAY
const selectTagsFilter = (state) => selectThreatProtectionList(state).tagsFilter ?? EMPTY_ARRAY
const selectDepartmentFilter = (state) =>
  selectThreatProtectionList(state).departmentFilter ?? EMPTY_ARRAY
const selectResolvedByFilter = (state) =>
  selectThreatProtectionList(state).resolvedByFilter ?? EMPTY_ARRAY
const selectReportedByFilter = (state) =>
  selectThreatProtectionList(state).reportedByFilter ?? EMPTY_ARRAY
const selectResolutionTypeFilter = (state) =>
  selectThreatProtectionList(state).resolutionTypeFilter ?? EMPTY_ARRAY
const selectThreatTypeFilter = (state) =>
  selectThreatProtectionList(state).threatTypeFilter ?? EMPTY_ARRAY

export {
  selectData,
  selectLoader,
  selectError,
  selectListType,
  selectSearch,
  selectDateFilter,
  selectParsedDate,
  selectPage,
  selectBannerTypeFilter,
  selectIncidentTypeFilter,
  selectTagsFilter,
  selectDepartmentFilter,
  selectResolvedByFilter,
  selectReportedByFilter,
  selectResolutionTypeFilter,
  selectThreatTypeFilter,
  selectDateRange,
}
